import React from 'react';
import { formatText } from 'core/i18n';

export const Header = () => {
    return (
        <div className="legal-info__doc-top">
            <div className="row">
                <div className="col-xs-12">
                    <div className="font-heading6--book">{formatText('fieldInfo-legal')}</div>
                </div>
            </div>
        </div>
    );
};
